module.exports = __webpack_public_path__ + "img/case-jsjcy.4b00a189.png";